import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import {
  ConfirmNewPhoneNumberResponse,
  CustomerContactDataDetails,
  CustomerFacade,
  MessageService,
  AppBarTitleService
} from "common";
import { ContactDataFormComponent } from "../contact-data-form-component";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
    selector: "ifp-customer-contact-data-form",
    templateUrl: "./customer-contact-data-form.component.html",
    styleUrls: ["./customer-contact-data-form.component.scss"],
    standalone: false
})
export class CustomerContactDataFormComponent extends ContactDataFormComponent implements OnInit {
  private customerContactData: CustomerContactDataDetails;

  constructor(
    formBuilder: UntypedFormBuilder,
    route: ActivatedRoute,
    router: Router,
    messageService: MessageService,
    private customerFacade: CustomerFacade,
    snackBar: MatSnackBar,
    appBarTitleService: AppBarTitleService
  ) {
    super(
      formBuilder,
      route,
      router,
      messageService,
      snackBar,
      appBarTitleService
    );
    this.formInit();
  }

  ngOnInit() {
    this.route.data
      .pipe(untilDestroyed(this))
      .subscribe(this.dataInit.bind(this));

    this.appBarTitleService.title = "Profile";
  }

  private dataInit(data: any): void {
    if (!data) return;

    this.customerContactData = data.customer;

    this.form.patchValue({
      mobilePhone: this.customerContactData?.mobilePhone,
      preferredPhone: this.customerContactData?.preferredPhone,
      homePhone: this.customerContactData?.homePhone,
      address: {
        line1: this.customerContactData?.address?.line1,
        line2: this.customerContactData?.address?.line2,
        city: this.customerContactData?.address?.city,
        state: this.customerContactData?.address?.state,
        zip: this.customerContactData?.address?.zip,
      },
    });
  }

  private formInit(): void {
    this.form = this.formBuilder.group({
      mobilePhone: ["", this.phoneValidator],
      preferredPhone: ["", this.phoneValidator],
      homePhone: ["", this.phoneValidator],
      address: this.getAddressFormGroup(),
    });
  }

  submit() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    const data = {
      address: Object.assign({}, this.form.value.address),
      mobilePhone: this.form.value.mobilePhone,
      preferredPhone: this.form.value.preferredPhone,
      homePhone: this.form.value.homePhone,
    };

    this.submitSub = this.customerFacade
      .updateCustomerContactDetails(this.customerContactData?.id, data)
      .subscribe(this.submitSuccess, this.submitError);
  }

  submitSuccess = () => {
    this.submitSubClear();
    this.messageService.success("Your data has been updated");
    this.customerFacade
      .confirmMobilePhoneNumberChange({
        customerId: this.customerContactData?.id,
        oldPhoneNumber: this.customerContactData.mobilePhone,
      })
      .subscribe((data: ConfirmNewPhoneNumberResponse) => {
        if (!data?.hasError) {
          this.customerFacade.redirectToDashboard();
        }
      });
  };
}
